var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#005741"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3629 19.9172V22.3097H10.6812C10.8143 20.7347 11.3131 19.627 13.0365 18.0685L20.3629 11.6965V17.2885H23V7H8.00294V12.1285H10.6393V9.68875H18.6064L11.316 16.0323L11.2984 16.0487C8.24274 18.8073 8 21.0332 8 23.656V25H22.9993V19.918H20.3622L20.3629 19.9172Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeta);
export default __webpack_public_path__ + "static/media/zeta.7938d0e95a7ac2145066664ab6c7d80b.svg";
export { ForwardRef as ReactComponent };